import React, { Component } from "react";
import { withStyles, styled } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid, TextField, Snackbar } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { Table, DatePicker, Button, Input, Select, Tabs } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { CloseOutlined, DeleteOutlined } from '@ant-design/icons'
const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
const { Option } = Select;

import {
  getStandardSubstanceList,
} from "../../actions/subscribe";

const styles = () => {
  return {
    root: {
      width: "100%",
    },
    search: {
      width: "100%",
      height: "61px",
      padding: "18px 24px",
      flexFlow: "column",
      background: "#fff",
    },
    line: {
      height: "25px",
      fontSize: "14px",
      color: "#000",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    btn: {
      width: "70px",
      height: "40px",
      background: "#3276C3",
      borderRadius: "0 !important",
    },
    container: {
      paddingTop: '20px'
    },
    tabBox: {
      height: "40px",
      "& .ant-tabs-nav": {
        marginBottom: "0 !important",
      },
      "& .ant-tabs-content-holder": {
        height: "0 !important",
      },
      "& .ant-tabs-tab-btn": {
        fontSize: "16px !important",
        fontWeight: "bold",
      },
    },
    tabContainer: {
      flex: "1",
      width: "100%",
      height: "1px",
      padding: "12px",
      background: "#fff",
      overflow: "hidden",
      boxShadow: "0 0 30px 10px rgba(0, 0, 0, .05)",
    },
    dateFilter: {
      width: "236px",
      padding: "8px",
    },
    defaultFilter: {
      width: "196px",
      padding: "8px",
    },
    btnLine: {
      marginTop: "8px",
      display: "flex",
      justifyContent: "space-between",
    },
    select: {
      width: "100%",
    },
    tableContainer: {
      width: "100%",
      "& .ant-table-cell-row-hover": {
        background: "#f0fbff !important",
      },
      "& td.ant-table-column-sort": {
        background: "#f0fbff !important",
      },
      "& .ant-table-cell": {
        wordBreak: "break-all !important",
      },
    },
    bold: {
      fontWeight: "bold",
    },
  };
};

class StandardSubstance extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    loading: true,
    filteredInfo: null,
    filterForm: {},
    filterDropdownVisible: false,
    columns: [],
    data: [],
    tabIndex: 0,
    updateTime: '',
    searchHistoryList: [],
    form: {},
    defaultForm: { // 默认值
      KeyWord: "",
      batchNumber: "",
      name: "",
      instructionLink: "",
      issueNumber: "",
      expectedListingTime: "",
      listingTime: "",
      DecommissionDate: [],
      releaseDate: [],
      supplyStatus: "",
      validPeriod: "",
      varietyCode: "",
    },
    labelObj: { // 筛选项key - label对应关系
      KeyWord: '关键词',
      batchNumber: '批号',
      name: '名称',
      instructionLink: '说明书',
      issueNumber: '期数',
      expectedListingTime: '预计上市时间',
      listingTime: '上市时间',
      DecommissionDate: '停用日期',
      releaseDate: '发布日期',
      supplyStatus: '供应情况',
      validPeriod: '有效使用期限',
      varietyCode: '品种编号',
    },
    labelListObj: { 
    },
    selectKeys: [],
    dataType: [],
    sourceList: [],
    defaultOrder: "descend",
    isPayList: [
      {
        ID: "是",
        Name: "是",
      },
      {
        ID: "否",
        Name: "否",
      },
    ],
    page: {
      page: 1,
      pageSize: 10,
    },
    total: 0,
    scrollObj: {
      x: 1600,
      y: 600,
    },
    sortObj: {
      SortCriteria: "TrainingTimeKS",
      SortCriteriaMode: "Desc",
    },
    paginationObj: {
      showSizeChanger: true,
      allTotal: 0,
      total: 0,
      showTotal: (total, range) => {
        return (
          "当前已筛选出【" +
          this.state.paginationObj.total +
          "】条，总数据量【" +
          this.state.paginationObj.allTotal +
          "】条"
        );
      },
      onChange: (page, pageSize) => {
        this.pageChange(page, pageSize);
      },
    },
  };

  getTableHeight = () => {
    // 计算表格高度
    let height = window.innerHeight
    let lineHeight = document.getElementById('searchBar').offsetHeight
    this.setState({
      scrollObj: {
        x: 1600,
        y: height - lineHeight - 211
      }
    })
  }

  componentDidMount() {
    this.getTableHeight()
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let today = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
    this.setState({
      updateTime: today
    })
    let search = decodeURI(this.props.location.search)
    let params = search.substring(1).split('&')
    let obj = params.find(v => {
      return v.indexOf('keyword=') == 0
    })
    if (obj) {
      let urlKeyword = obj.split('=')[1]
      this.setState({
        form: {
          ...this.state.form,
          KeyWord: urlKeyword,
        },
        showKeys: ['KeyWord']
      }, () => this.initData())
    } else {
      this.initData()
    }
  }

  resetForm = () => {
    this.setState({
      form: {
        KeyWord: "",
        SourceOrganization: undefined,
        TrainingContent: "",
        TrainingTime: [],
        HowToAttend: "",
        WhetherToPay: undefined,
        WebUrl: "",
        Remarks: "",
      }
    })
  }

  clearHistory = () => {
    this.resetForm()
    this.setState({
      searchHistoryList: []
    }, () => this.initData())
  }

  removeSearchItem = (data, i) => {
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    form[data.key] = this.state.defaultForm[data.key]
    list.splice(i, 1)
    this.setState({
      form: form,
      searchHistoryList: list
    }, () => this.initData())
  }

  searchForm = () => {
    this.initData()
    // 添加历史搜索记录
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    for (let key in form) {
      let index = list.findIndex(v => {
        return v.key == key
      })
      if (form[key] && form[key].length > 0) {
        let showValue = form[key]
        let label = ''
        if (key == 'DecommissionDate' || key == 'releaseDate') {
          showValue = `${showValue[0].format("YYYY-MM-DD")} - ${showValue[1].format("YYYY-MM-DD")}`
        }
        if (this.state.selectKeys.indexOf(key) > -1) {
          label = this.state[this.state.labelListObj[key]].find(v => {
            return v.ID == showValue
          }).Name
        }
        if (index === -1) {
          let param = {
            label: this.state.labelObj[key],
            value: label || showValue,
            key: key
          } 
          list.push(param)
        } else {
          let itemIndex = list.findIndex(v => {
            return v.key == key
          })
          list[itemIndex].value = label || showValue
        }
      } else {
        if (index > -1) {
          list.splice(index, 1)
        }
      }
    }
    this.setState({
      searchHistoryList: list
    })
  }

  onChangeForm = (value, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = value
    this.setState({
      form: form
    })
  }

  initData = () => {
    let DecommissionDate = this.state.form.DecommissionDate
    let releaseDate = this.state.form.releaseDate
    let param = Object.assign(
      {},
      this.state.form,
      this.state.page,
    );
    if (DecommissionDate && DecommissionDate.length > 0) {
      param.startDecommissionDate = DecommissionDate[0].format("YYYY-MM-DD")
      param.endDecommissionDate = DecommissionDate[1].format("YYYY-MM-DD")
    }
    if (releaseDate && releaseDate.length > 0) {
      param.startReleaseDate = releaseDate[0].format("YYYY-MM-DD")
      param.endReleaseDate = releaseDate[1].format("YYYY-MM-DD")
    }
    delete(param.DecommissionDate)
    delete(param.releaseDate)
    getStandardSubstanceList(param).then((res) => {
      if (!res.Error) {
        let newPaginationObj = this.state.paginationObj;
        newPaginationObj.total = res.DataNumber;
        newPaginationObj.allTotal = res.UnfilteredAllDataNumber;
        this.setState(
          {
            data: res.DataList,
            paginationObj: newPaginationObj,
            loading: false,
          },
          () => {
            this.getColumns();
          }
        );
      } else {
        this.setState({
          loading: false,
          data: [],
        });
      }
    });
  };

  getColumns = () => {
    let classes = this.props.classes;

    let columns = [
      {
        title: "批号",
        dataIndex: "batchNumber",
        width: 130,
        key: "batchNumber",
      },
      {
        title: "名称",
        dataIndex: "name",
        width: 200,
        key: "name",
      },
    
      {
        title: "预计上市时间",
        dataIndex: "expectedListingTime",
        key: "expectedListingTime",
        width: 140,
      },
      {
        title: "说明书",
        dataIndex: "instructionLink",
        key: "instructionLink",
        width: 140,
        render: (instructionLink) => (
          instructionLink ? <a href={instructionLink} target="_blank">{instructionLink}</a> :
          <span></span>
        ),
      },
      {
        title: "期数",
        dataIndex: "issueNumber",
        key: "issueNumber",
        width: 140,
      },
      {
        title: "上市时间",
        dataIndex: "listingTime",
        key: "listingTime",
        width: 140,
      },
      {
        title: "停用日期",
        dataIndex: "DecommissionDate",
        key: "decommissionDate",
        width: 140,
        render: (releaseDate) => (
          <span>{releaseDate ? releaseDate.substring(0, 10) : ''}</span>
        ),
      },
      {
        title: "发布日期",
        dataIndex: "releaseDate",
        width: 160,
        key: "releaseDate",
        render: (releaseDate) => (
          <span>{releaseDate ? releaseDate.substring(0, 10) : ''}</span>
        ),
      },
      {
        title: "供应情况",
        dataIndex: "supplyStatus",
        width: 140,
        key: "supplyStatus",
      },
      {
        title: "有效使用期限",
        dataIndex: "validPeriod",
        width: 140,
        key: "validPeriod",
      },
      {
        title: "品种编号",
        dataIndex: "varietyCode",
        width: 130,
        key: "varietyCode",
      },
    ];

    this.setState({
      columns: columns,
    });
  };

  handleChange = (pagination, filters, sorter) => {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.getColumns();
        this.initData();
      }
    );
  };

  handleSort = () => {};

  clearFilters = () => {
    this.setState({ filteredInfo: null });
  };

  clearAll = () => {
    this.setState(
      {
        filteredInfo: null,
        page: {
          page: 1,
          pageSize: 10,
        },
        form: {},
        loading: true,
      },
      () => {
        this.getColumns();
        this.initData();
      }
    );
  };

  handleReset = (clearFilters) => {
    clearFilters();
  };



  pageChange = (page, pageSize) => {
    if (
      page == this.state.page.page &&
      pageSize == this.state.page.pageSize
    ) {
      return;
    }
    this.setState(
      {
        page: {
          page: page,
          pageSize: pageSize,
        },
        loading: true,
      },
      () => this.initData()
    );
  };

  render() {
    const classes = this.props.classes;

    return (
      <div className="common-page">
        <div className="common-left-search">
          <div className="left-search-title">
            <span className="search-title">关键词搜索</span>
            
          </div>
          <div className="search-form">
            <div className="form-item">
              <div className="form-label">关键词</div>
              <Input  value={this.state.form.KeyWord}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'KeyWord')} 
                placeholder="请输入关键词"/>
            </div>
            <div className="form-item">
              <div className="form-label">批号</div>
              <Input  value={this.state.form.batchNumber}
                onChange={(e) => this.onChangeForm(e.target.value, 'batchNumber')} 
                placeholder="请输入批号"/>
            </div>

            <div className="form-item">
              <div className="form-label">名称</div>
              <Input  value={this.state.form.name}
                onChange={(e) => this.onChangeForm(e.target.value, 'name')} 
                placeholder="请输入名称"/>
            </div>
            <div className="form-item">
              <div className="form-label">说明书</div>
              <Input  value={this.state.form.instructionLink}
                onChange={(e) => this.onChangeForm(e.target.value, 'instructionLink')} 
                placeholder="请输入说明书"/>
            </div>
            <div className="form-item">
              <div className="form-label">期数</div>
              <Input  value={this.state.form.issueNumber}
                onChange={(e) => this.onChangeForm(e.target.value, 'issueNumber')} 
                placeholder="请输入期数"/>
            </div>
            <div className="form-item">
              <div className="form-label">预计上市时间</div>
              <Input  value={this.state.form.expectedListingTime}
                onChange={(e) => this.onChangeForm(e.target.value, 'expectedListingTime')} 
                placeholder="请输入预计上市时间"/>
            </div>
            <div className="form-item">
              <div className="form-label">上市时间</div>
              <Input  value={this.state.form.listingTime}
                onChange={(e) => this.onChangeForm(e.target.value, 'listingTime')} 
                placeholder="请输入上市时间"/>
            </div>
            <div className="form-item">
              <div className="form-label">停用日期</div>
              <RangePicker
                value={this.state.form.DecommissionDate}
                onChange={(value) => this.onChangeForm(value, 'DecommissionDate')}
              />
            </div>
            <div className="form-item">
              <div className="form-label">发布日期</div>
              <RangePicker
                value={this.state.form.releaseDate}
                onChange={(value) => this.onChangeForm(value, 'releaseDate')}
              />
            </div>
            <div className="form-item">
              <div className="form-label">供应情况</div>
              <Input  value={this.state.form.supplyStatus}
                onChange={(e) => this.onChangeForm(e.target.value, 'supplyStatus')} 
                placeholder="请输入供应情况"/>
            </div>
            <div className="form-item">
              <div className="form-label">有效使用期限</div>
              <Input  value={this.state.form.validPeriod}
                onChange={(e) => this.onChangeForm(e.target.value, 'validPeriod')} 
                placeholder="请输入有效使用期限"/>
            </div>
            <div className="form-item">
              <div className="form-label">品种编号</div>
              <Input  value={this.state.form.varietyCode}
                onChange={(e) => this.onChangeForm(e.target.value, 'varietyCode')} 
                placeholder="请输入品种编号"/>
            </div>
            

          </div>

          <div className="search-bottom-btns">
            <Button className="default-btn" onClick={this.resetForm}>重置</Button>
            <Button className="primary-btn" onClick={this.searchForm}>搜索</Button>
          </div>
        </div>

        <div className="common-main">
          <div className="common-main-search" id="searchBar">
            <div className="main-title">
              <div className="title-top">
                <div>
                  <span className="page-title">标准物质</span>
                  <span className="page-count">{this.state.paginationObj.total}条</span>
                </div>
                <span >数据更新至：{this.state.updateTime}</span>
              </div>
            </div>
            {
              this.state.searchHistoryList.length > 0 &&
              <div className="search-history">
                {
                  this.state.searchHistoryList.map((item, i) => (
                    <div className="history-item" key={i}>
                      <span>{item.label}：</span>
                      <span className="history-value">{item.value}</span>
                      <CloseOutlined className="clear-icon" onClick={() => this.removeSearchItem(item, i)}/>
                    </div>
                  ))
                }
                <div className="hitstory-btn" onClick={this.clearHistory}>
                  <DeleteOutlined className="btn-icon"/>
                  清空
                </div>
              </div>
            }
          </div>
          <div className="common-main-container">
            <Grid container className={classes.container} id="tableContainer">
              <Table
                className={classes.tableContainer}
                columns={this.state.columns}
                loading={this.state.loading}
                dataSource={this.state.data}
                onChange={this.handleChange}
                pagination={this.state.paginationObj}
                scroll={this.state.scrollObj}
                bordered
              />
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(StandardSubstance));
